export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8080';

export const fetchWithCredentials = (url, options = {}) => {
    return fetch(url, {
        ...options,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        }
    });
};
